import React, { useState } from "react";
import { ChevronDown, ChevronRight, HelpCircle } from "lucide-react";

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqData = [
    {
      question: "What makes your leads different from others?",
      answer:
        "Our leads are 100% exclusive. Unlike generic vendors who resell leads to multiple firms, we send every lead only to you, giving your firm the highest chance to convert.",
    },
    {
      question: "Which types of accident cases do you cover?",
      answer:
        "We specialize in motor vehicle accident leads, including car, truck, motorcycle, pedestrian, rideshare, and commercial vehicle accidents.",
    },
    {
      question: "How do you generate leads?",
      answer:
        "We use a proven mix of SEO, Google Ads, social media campaigns, and conversion funnels to reach accident victims actively searching for legal help.",
    },
    {
      question: "Are your strategies compliant with legal advertising rules?",
      answer:
        "Yes. Compliance and ethics are built into everything we do. Our campaigns are designed around state bar advertising standards, protecting your firm’s reputation.",
    },
    {
      question: "How soon will I start seeing leads?",
      answer:
        "Timelines can vary depending on your market, practice area, and campaign setup. Many firms begin receiving accident leads within the first month, but results will depend on targeting and strategy.",
    },
  ];

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="min-h-screen bg-white flex flex-col">
      {/* Hero Section */}
      <section className="py-12 sm:py-16 lg:py-24 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto text-center">
          <div className="flex justify-center mb-6">
            <div className="bg-[#0B2C56] p-4 rounded-full shadow-md">
              <HelpCircle size={56} className="text-[#FC821F]" />
            </div>
          </div>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl 2xl:text-6xl font-bold text-[#0A476C] leading-tight">
            <span className="text-[#FC821F]">Frequently </span>
            Asked Questions
          </h1>
        </div>
      </section>

      {/* FAQ Content */}
      <section className="flex-1 max-w-5xl w-full mx-auto px-4 sm:px-6 lg:px-8 pb-16">
        <div className="space-y-4">
          {faqData.map((item, index) => {
            const isActive = activeIndex === index;

            return (
              <div
                key={index}
                className="bg-gray-50 rounded-2xl border border-gray-200 overflow-hidden shadow-sm transition"
              >
                <button
                  onClick={() => toggleAccordion(index)}
                  className="w-full px-6 py-5 text-left flex items-center justify-between"
                >
                  <span className="text-base sm:text-lg lg:text-xl font-semibold text-gray-800 pr-4">
                    {item.question}
                  </span>
                  {isActive ? (
                    <ChevronDown
                      className="text-[#FC821F] flex-shrink-0"
                      size={24}
                    />
                  ) : (
                    <ChevronRight
                      className="text-gray-400 flex-shrink-0"
                      size={24}
                    />
                  )}
                </button>
                <div
                  className={`grid transition-all duration-300 ease-in-out ${
                    isActive
                      ? "grid-rows-[1fr] opacity-100"
                      : "grid-rows-[0fr] opacity-0"
                  }`}
                >
                  <div className="overflow-hidden">
                    <div className="px-6 pb-6 border-t border-gray-200 pt-4">
                      <p className="text-gray-600 text-sm sm:text-base lg:text-lg leading-relaxed">
                        {item.answer}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </section>
    </div>
  );
};

export default FAQ;
